import React, { useEffect } from "react"
import {
    Checkbox,
    FormControl,
    FormHelperText,
    Grid,
    Input,
    InputLabel,
    ListItemText,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Typography
} from "@material-ui/core"
import PlatformRequest from "../../utils/PlatformRequest"
import LoadPage from "../../components/LoadPage"
import InputMask from 'react-input-mask'

const useStyles = makeStyles((theme) => ({
    boxRegister: {
        padding: 40,
    },
    logo: {
        marginTop: 30,
        marginBottom: 30
    },
    formControl: {
        display: "Grid",
        gridTemplateColumns: `repeat(auto-fill, minmax(0, 300px))`
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        height: 40
    }
}))
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
            minWidth: 230,
            maxWidth: 400,
        },
    },
}

const ProviderCompanyInfo = (props) => {
    const classes = useStyles()
    const [ssnValid, setSsnValid] = React.useState({
        valid: true,
        message: ""
    })
    const nationalityList = [
        "Nacional",
        "Importado"
    ]
    const carTypeList = [
        "Carro",
        "Moto",
        "Caminhão",
        "Utilitários",
    ]
    const partTypeList = [
        "Nova Original",
        "Nova Paralela",
        "Usada Original",
    ]
    const [brandCarList, setBrandCarList] = React.useState([
        {
            id: "",
            description: ""
        }
    ])
    const [segmentList, setSegmentList] = React.useState([
        {
            id: "",
            description: ""
        }
    ])
    const [load, setLoad] = React.useState(false)

    useEffect(() => {
        setLoad(true)
        const promises = [
            PlatformRequest.getBrands(),
            PlatformRequest.getSegments()
        ]

        Promise.all(promises).then((response) => {
            const segments = response[1].body
            const brands = response[0].body

            setBrandCarList(brands)
            setSegmentList(segments)

            if (props.edit) {
                props.loadProvider(segments, brands)
            }

            setLoad(false)
        })
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const changeSelectValue = (event) => {
        props.updateProvider({ ...props.provider, [event.target.name]: event.target.value })
    }

    const changeValue = (event) => {
        props.updateProvider({ ...props.provider, [event.target.name]: event.target.value })
    }

    const validateCnpj = (event) => {
        if (props.ssnDisabled) {
            setSsnValid({ valid: false, message: "Para editar esse campo, entre em contato com a equipe do Deixa Que Eu Procuro" })
            props.validSsn(true)
            return
        }

        const value = event.target.value.replace(/[^\d]+/g, '')

        if (value.length === 14) {
            PlatformRequest.getProviderExist(value)
                .then((response) => {
                    const { status } = response

                    switch (status) {
                        case 200: setSsnValid({ valid: false, message: "Fornecedor já cadastrado" })
                            props.validSsn(false)
                            break
                        case 422: setSsnValid({ valid: false, message: "CNPJ inválido" })
                            props.validSsn(false)
                            break
                        case 404: setSsnValid({ valid: true, message: "" })
                            props.validSsn(true)
                            break
                        default:
                            setSsnValid({ valid: false, message: "" })
                    }
                })
        }

    }

    return (
        <div>
            <LoadPage load={load} />
            <Grid container direction="row"
                justifyContent="center"
                spacing={2}
                alignItems="center">
                <Grid item xs={12} lg={12} md={12}>
                    <Typography variant="subtitle2" gutterBottom>
                        Dados Empresariais
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                    <InputMask
                        mask="99.999.999/9999-99"
                        onChange={changeValue}
                        value={props.provider.ssn}
                        maskChar=" "
                        disabled={props.ssnDisabled ? true : false}
                    >
                        {() =>
                            <TextField
                                label="Informe seu CNPJ"
                                margin="normal"
                                autoFocus
                                required
                                onKeyUp={validateCnpj}
                                error={!ssnValid.valid}
                                helperText={!ssnValid.valid ? ssnValid.message : ""}
                                id="ssn"
                                name="ssn"
                                variant="outlined"
                                fullWidth />}
                    </InputMask>
                </Grid>
                <Grid item xs={12} lg={6} md={6}>
                    <TextField
                        label="Informe sua Razão Social *"
                        margin="normal"
                        onChange={changeValue}
                        id="companyName"
                        name="companyName"
                        helperText={props.required.companyName ? "Campo obrigatório" : ""}
                        variant="outlined"
                        error={props.required.companyName}
                        value={props.provider.companyName}
                        fullWidth />
                </Grid>
                <Grid item xs={12} lg={6} md={6}>
                    <TextField
                        label="Informe o Nome Fantasia *"
                        helperText={props.required.fancyName ? "Campo obrigatório" : ""}
                        margin="normal"
                        onChange={changeValue}
                        id="fancyName"
                        name="fancyName"
                        variant="outlined"
                        error={props.required.fancyName}
                        value={props.provider.fancyName}
                        fullWidth />
                </Grid>

                <Grid item xs={6} lg={6} md={6}>
                    <InputMask
                        mask="(99) 9 9999-9999"
                        onChange={changeValue}
                        value={props.provider.phone}
                        maskChar=" "
                    >
                        {() =>
                            <TextField
                                label="Informe seu telefone para contato"
                                margin="normal"
                                autoFocus
                                required
                                error={props.required.phone}
                                value={props.provider.phone}
                                id="phone"
                                name="phone"
                                variant="outlined"
                                fullWidth />}
                    </InputMask>
                </Grid>
                <Grid item xs={6} lg={6} md={6}>
                    <TextField
                        label="Informe seu email para contato"
                        margin="normal"
                        onChange={changeValue}
                        id="email"
                        name="email"
                        variant="outlined"
                        value={props.provider.email}
                        fullWidth />
                </Grid>
            </Grid>
            <br />
            <Grid container direction="row"
                justifyContent="center"
                spacing={2}
                alignItems="center">
                <Grid item xs={12} lg={12} md={12}>
                    <Typography variant="subtitle2" gutterBottom>
                        Tipos de Serviço
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={6} md={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="type-label">Tipo de Veículo</InputLabel>
                        <Select
                            labelId="type-label"
                            id="type-label"
                            multiple
                            error={props.required.carType}
                            variant="outlined"
                            value={props.provider.carTypeList}
                            onChange={changeSelectValue}
                            name="carTypeList"
                            input={<Input />}
                            fullWidth
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={MenuProps}>
                            {carTypeList.map((carType) => (
                                <MenuItem key={carType} value={carType}>
                                    <Checkbox checked={props.provider.carTypeList.indexOf(carType) > -1} />
                                    <ListItemText primary={carType} />
                                </MenuItem>
                            ))}
                        </Select>
                        {
                            props.required.carType ? (<FormHelperText>Campo obrigatório</FormHelperText>) : ""
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} lg={6} md={12}></Grid>
                <Grid item xs={12} lg={6} md={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="nationality-label">Nacionalide</InputLabel>
                        <Select
                            labelId="nationality-label"
                            id="nationality-label"
                            multiple
                            variant="outlined"
                            error={props.required.nationality}
                            value={props.provider.nationalityList}
                            onChange={changeSelectValue}
                            input={<Input />}
                            fullWidth
                            name="nationalityList"
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={MenuProps}>
                            {nationalityList.map((nationality) => (
                                <MenuItem key={nationality} value={nationality}>
                                    <Checkbox
                                        checked={props.provider.nationalityList.indexOf(nationality) > -1} />
                                    <ListItemText primary={nationality} />
                                </MenuItem>
                            ))}
                        </Select>
                        {
                            props.required.nationality ? (
                                <FormHelperText>Campo obrigatório</FormHelperText>) : ""
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} lg={6} md={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="part-label">Peças</InputLabel>
                        <Select
                            labelId="part-label"
                            id="part-label"
                            name="carPartList"
                            multiple
                            variant="outlined"
                            error={props.required.part}
                            value={props.provider.carPartList}
                            onChange={changeSelectValue}
                            input={<Input />}
                            fullWidth
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={MenuProps}>
                            {partTypeList.map((partType) => (
                                <MenuItem key={partType} value={partType}>
                                    <Checkbox checked={props.provider.carPartList.indexOf(partType) > -1} />
                                    <ListItemText primary={partType} />
                                </MenuItem>
                            ))}
                        </Select>
                        {
                            props.required.part ? (<FormHelperText>Campo obrigatório</FormHelperText>) : ""
                        }
                    </FormControl>
                </Grid>
            </Grid>
            <br />
            <br />
            <Grid container direction="row"
                justifyContent="center"
                spacing={2}
                alignItems="center">
                <Grid item xs={12} lg={12} md={12}>
                    <Typography variant="subtitle2" gutterBottom>
                        Seguimentos e Marcas
                    </Typography>
                </Grid>

                <Grid item xs={12} lg={6} md={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="segments-label">Selecione os Seguimentos</InputLabel>
                        <Select
                            labelId="segments-label"
                            id="segments-label"
                            multiple
                            name="segmentList"
                            variant="outlined"
                            error={props.required.segment}
                            value={props.provider.segmentList}
                            onChange={changeSelectValue}
                            input={<Input />}
                            fullWidth
                            renderValue={(selected) => {
                                const description = selected.map((item) => item.description)
                                return description.join(', ')
                            }}
                            MenuProps={MenuProps}>
                            {segmentList.map((segment, index) => (
                                <MenuItem key={`segment${index}`} value={segment}>
                                    <Checkbox checked={props.provider.segmentList.indexOf(segment) > -1} />
                                    <ListItemText primary={segment.description} />
                                </MenuItem>
                            ))}
                        </Select>
                        {
                            props.required.segment ? (<FormHelperText>Campo obrigatório</FormHelperText>) : ""
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12} lg={6} md={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="brand-label">Marcas de Veículo</InputLabel>
                        <Select
                            labelId="brand-label"
                            id="brand-label"
                            multiple
                            name="carBrandList"
                            variant="outlined"
                            error={props.required.brand}
                            value={props.provider.carBrandList}
                            onChange={changeSelectValue}
                            input={<Input />}
                            fullWidth
                            renderValue={(selected) => {
                                const description = selected.map((item) => item.description)
                                return description.join(', ')
                            }}
                            MenuProps={MenuProps}>
                            {brandCarList.map((brand, index) => (
                                <MenuItem key={`brand${index}`} value={brand}>
                                    <Checkbox checked={props.provider.carBrandList.indexOf(brand) > -1} />
                                    <ListItemText primary={brand.description} />
                                </MenuItem>
                            ))}
                        </Select>
                        {
                            props.required.brand ? (<FormHelperText>Campo obrigatório</FormHelperText>) : ""
                        }
                    </FormControl>
                </Grid>
            </Grid>
        </div>
    )

}

export default ProviderCompanyInfo